/*
A set that allows adding values and checking if it contains a value. contains() removes the item from the list.
 */
angular.module('aprima-core').factory('SingleAccessSet', [function() {
    'use strict';

    function SingleAccessSet() {
        this.set = {};
    }

    SingleAccessSet.prototype.add = function add(key) {
        this.set[key] = true;
    };

    SingleAccessSet.prototype.contains = function contains(key) {
        var exists = !!this.set[key];
        delete this.set[key];
        return exists;
    };

    return SingleAccessSet;
}]);